<template>
  <div>
    <v-app-bar
      fixed
      dark
      flat
      style="z-index: 8;background: transparent;"
      :class="windowTop ? 'nav_down' : 'nav_up'"
      extended
    >
      <v-toolbar-title
        class="text-uppercase grey--text"
        @click="goHome"
        style="cursor:pointer;position:relative"
      >
        <v-img
          style="color:white;text-shadow: 1px 1px 6px black;z-index: 17;position:relative;"
          v-if="$vuetify.breakpoint.mdAndUp"
          :src="require('../assets/logo.png')"
          :height="24"
          :width="80"
          contain
        ></v-img>
      </v-toolbar-title>

      <v-toolbar-items
        style="z-index: 7;"
        class="ml-10"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-btn
          class="text-lowercase font-weight-light"
          router
          :to="'/'"
          tile
          text
        >
          Start
        </v-btn>

        <v-btn
          router
          :to="'/donations'"
          class="text-lowercase font-weight-light"
          text
        >
          Donationer
        </v-btn>

        <v-btn
          router
          :to="'/streamhotel'"
          class="text-lowercase font-weight-light"
          text
        >
          Stream Hotel
        </v-btn>
        <v-btn
          router
          :to="'/spons'"
          class="text-lowercase font-weight-light"
          text
        >
          Spons
        </v-btn>
        <v-btn
          router
          :to="'/events'"
          class="text-lowercase font-weight-light"
          text
        >
          Events
        </v-btn>

        <v-btn
          router
          :to="'/about'"
          class="text-lowercase font-weight-light"
          text
        >
          Om oss
        </v-btn>
      </v-toolbar-items>
      <v-img
        style="color:white;text-shadow: 1px 1px 6px black;z-index: 17;position:relative;"
        v-if="!$vuetify.breakpoint.mdAndUp"
        :src="require('../assets/logo.png')"
        :height="12"
        :width="40"
        contain
        @click="goHome"
        v-ripple
      ></v-img>
      <v-tabs
        v-if="!$vuetify.breakpoint.mdAndUp"
        background-color="transparent"
        grow
        center-active
        style="max-width:60%;"
        hide-slider
        class="hide_prev"
      >
        <v-tabs-slider color=""></v-tabs-slider>

        <v-tab
          router
          :to="'/donations'"
          class="text-lowercase font-weight-light"
        >
          Donationer
        </v-tab>
        <v-tab
          router
          :to="'/streamhotel'"
          class="text-lowercase font-weight-light"
        >
          Stream Hotel
        </v-tab>
        <v-tab router :to="'/spons'" class="text-lowercase font-weight-light">
          Spons
        </v-tab>
        <v-tab router :to="'/events'" class="text-lowercase font-weight-light">
          Events
        </v-tab>
        <v-tab router :to="'/about'" class="text-lowercase font-weight-light">
          Om oss
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        app
        @click="$store.state.APP.DRAWER_MENU = !$store.state.APP.DRAWER_MENU"
        style="position: relative;z-index: 8;"
        class="justify-center"
        v-if="$vuetify.breakpoint.smAndDown && $store.getters.loggedIn"
      ></v-app-bar-nav-icon>

      <v-btn
        app
        style="z-index: 8;"
        v-if="!$store.getters.loggedIn"
        @click="$store.state.APP.SHOW_LOGIN = true"
        text
      >
        <span style="">Logga in</span>
        <v-icon style="" right>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      windowTop: true,
      showAlert: true,
    };
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    isBig: function() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isPage: function() {
      return this.$route.name === "MyPage.vue";
    },

    user: function() {
      let full = this.$store.state.STREAMER.USER_NAME;
      if (full.length > 18) {
        return full.substring(0, 17) + "..";
      } else {
        return full;
      }
    },
  },
  methods: {
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    onScroll() {
      if (window.top.scrollY >= 100) {
        //set windowTop to false if the user scrolls down past 100px
        this.windowTop = false;
      } else {
        this.windowTop = true;
      }
    },
  },
};
</script>

<style>
.hide_prev > .v-item-group > .v-slide-group__prev {
  display: none !important;
}

.translate-up {
  -webkit-transition: all 500ms ease-in-out 25ms;
  transition: all 500ms ease-in-out 25ms;
  -ms-transform: translateY(60px) !important;
  -moz-transform: translateY(60px) !important;
  -webkit-transform: translateY(60px) !important;
  -o-transform: translateY(60px) !important;
  transform: translateY(60px) !important;
}
.nav_up {
  transform: translateY(-60px) !important;
}

.nav_down {
  transform: translateY(0) !important;
}
</style>
